import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combine conditional class names and de-duplicate Tailwind utilities.
 * Preferred over raw string concatenation so last-writer-wins conflicts
 * (`p-2 p-4` → `p-4`) resolve the way humans expect.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
